// Standard Checkout retains all eligible, account-enabled methods.
export const RAZORPAY_DISPLAY_CONFIG = {
  display: {
    blocks: {
      travel_payment: {
        name: "Pay for your holiday",
        instruments: [{ method: "upi" }, { method: "card" }, { method: "netbanking" }, { method: "emi" }],
      },
    },
    sequence: ["block.travel_payment"],
    preferences: { show_default_blocks: true },
  },
};

let razorpayScriptPromise = null;
export function loadRazorpayScript() {
  if (window.Razorpay) return Promise.resolve(true);
  if (razorpayScriptPromise) return razorpayScriptPromise;
  razorpayScriptPromise = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    let finished = false;
    const fail = () => {
      if (finished) return;
      finished = true;
      clearTimeout(timeout);
      script.remove();
      razorpayScriptPromise = null;
      reject(new Error("Unable to load secure checkout. Please try again."));
    };
    const timeout = setTimeout(fail, 15000);
    script.onload = () => {
      if (!window.Razorpay) { fail(); return; }
      if (finished) return;
      finished = true;
      clearTimeout(timeout);
      resolve(true);
    };
    script.onerror = fail;
    document.body.appendChild(script);
  });
  return razorpayScriptPromise;
}
